import AnalyticsMenuBar from "./analitycs-menu-bar";

export default AnalyticsMenuBar;